import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { PageHero } from "../components/programmatic/PageHero"
import { Breadcrumbs } from "../components/programmatic/Breadcrumbs"
import { ServiceCTA } from "../components/programmatic/ServiceCTA"
import { AuthorBox } from "../components/programmatic/AuthorBox"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"
import { buildBreadcrumbList } from "../components/SEO/schema/breadcrumbList"
import locations from "../data/locations.json"
import type { LocationPage } from "../data/types"

const entries = locations as LocationPage[]

const PortoAlegrePage = () => {
  const crumbs = [
    { name: "Início", to: "/" },
    { name: "Porto Alegre", to: "/porto-alegre" },
  ]

  const jsonLd = [buildLocalBusiness(), buildBreadcrumbList(crumbs)]

  return (
    <Layout>
      <SEO
        title="Atendimento em Porto Alegre"
        description="Atendimento presencial de Reiki, Tarô Alquímico, Florais e Barras de Access em Porto Alegre. Veja onde atendo e agende pelo WhatsApp."
        canonicalPath="/porto-alegre"
        jsonLd={jsonLd}
      />
      <Breadcrumbs crumbs={crumbs} />
      <PageHero
        eyebrow="Porto Alegre"
        headline="Atendimento em Porto Alegre"
        intro="Atendo presencialmente em Porto Alegre — Reiki, Tarô Alquímico, Barras de Access e consultas de Florais Alkhemy Lab. Veja por bairro e por modalidade."
      />
      <section className="text-gray-700 body-font">
        <div className="container mx-auto px-5 py-10">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
            {entries.map((entry) => (
              <li key={entry.slug}>
                <Link
                  to={`/${entry.slug}`}
                  className="block bg-purple-50 hover:bg-purple-100 rounded p-5 transition-colors"
                >
                  <h2 className="text-lg font-medium text-gray-900 mb-2">
                    {entry.serviceLabel} em {entry.areaLabel}
                  </h2>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    {entry.intro}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <ServiceCTA prefill="Olá Gabriela, vim da página de Porto Alegre do site e gostaria de agendar." />
      <AuthorBox />
    </Layout>
  )
}

export default PortoAlegrePage
